import grid from 'blocks.simple/grid/grid.jcss'
import { addStyles } from 'ethcss'
import { IStyles } from 'theme'
import { colors, indents, textSizes } from 'theme'

export const authenticationSettingsStyles: IStyles = {
    gateCard: {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 12,
        padding: 16,
        maxWidth: 766,
        background: colors.white,
        border: '1px solid rgba(26, 26, 35, 0.12)',
        borderRadius: 12,
    },
    gateHeader: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 8,
        width: '100%',
    },
    gateIcon: {
        boxSizing: 'border-box',
        width: 28,
        height: 28,
        borderRadius: 4,
        padding: 4,
        background: 'rgba(40, 108, 242, 0.05)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    gateTitle: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '20px',
        color: '#1a1a23',
    },
    gateDesc: {
        fontSize: 14,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.6)',
        width: '100%',
    },
    gateCodeRow: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
    },
    gateSendBtn: {
        width: 'fit-content',
        alignSelf: 'flex-start',
    },
    gateInput: {
        maxWidth: 260,
        flex: '0 0 260px',
        minWidth: 180,
    },
    gateResendRow: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 12,
        flexWrap: 'wrap',
        width: '100%',
        fontSize: 14,
        lineHeight: '20px',
    },
    gateResendMuted: {
        color: 'rgba(26, 26, 35, 0.36)',
    },
    gateResendTimer: {
        color: 'rgba(26, 26, 35, 0.84)',
    },
    gateResendLink: {
        padding: 0,
        border: 0,
        background: 'transparent',
        color: colors.blueAccent,
        fontSize: 14,
        lineHeight: '20px',
        cursor: 'pointer',
        '&:disabled': {
            color: 'rgba(26, 26, 35, 0.36)',
            cursor: 'default',
        },
    },
    authenticationSettings__inner: {
        paddingTop: indents.md,
    },
    authenticationSettings__subText: {
        paddingBottom: indents.md,
        fontWeight: 'bold',
    },
    authenticationSettings__row: {
        ...grid.flex,
        ...grid.normalCenter,
        ...grid.row,
        ...grid.noWrap,
        paddingBottom: indents.mdPlus,
        '&:last-child': {
            paddingBottom: 0,
        },
    },
    authenticationSettings__content: {
        paddingLeft: indents.mini,
        fontSize: textSizes.normal,
        color: colors.grey,
    },
    authenticationSettings__icon: {
        display: 'inline-block',
    },
    authenticationSettings__text: {
        paddingRight: indents.mini,
    },
    authenticationSettings__input: {
        maxWidth: 300,
        paddingRight: indents.mini,
    },
    totpSection: {
        ...grid.col,
        gap: 24,
    },
    toggleRow: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 12,
    },
    toggleLabel: {
        flex: 1,
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '16px',
        color: '#1a1a23',
    },
    sectionHint: {
        fontSize: 14,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.6)',
    },
    methodsFieldset: {
        border: 0,
        margin: 0,
        padding: 0,
        minWidth: 0,
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        '&:disabled': {
            opacity: 0.55,
        },
    },
    methodsLegend: {
        float: 'none',
        width: '100%',
        padding: 0,
        margin: '0 0 16px',
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px',
        color: '#1a1a23',
    },
    methodCards: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
        gap: 12,
        alignItems: 'stretch',
    },
    backupCodesCard: {
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 16,
        padding: 16,
        background: 'rgba(26, 26, 35, 0.04)',
        border: '1px solid rgba(26, 26, 35, 0.12)',
        borderRadius: 12,
        flexWrap: 'wrap',
        width: '100%',
    },
    backupCodesInfo: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        minWidth: 0,
        flex: 1,
    },
    backupCodesTitleRow: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 8,
    },
    backupCodesIcon: {
        boxSizing: 'border-box',
        width: 28,
        height: 28,
        borderRadius: 4,
        padding: 4,
        background: 'rgba(26, 26, 35, 0.08)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    backupCodesDesc: {
        fontSize: 14,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.84)',
    },
    methodCard: {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        padding: 16,
        background: colors.white,
        border: '1px solid rgba(26, 26, 35, 0.12)',
        borderRadius: 12,
        minWidth: 0,
    },
    methodCardHeader: {
        ...grid.row,
        ...grid.normalCenter,
        ...grid.justify,
        gap: 12,
        width: '100%',
    },
    methodCardTitleRow: {
        ...grid.row,
        ...grid.normalCenter,
        gap: 8,
        flexWrap: 'wrap',
        minWidth: 0,
        flex: 1,
    },
    methodIcon: {
        boxSizing: 'border-box',
        width: 28,
        height: 28,
        borderRadius: 4,
        padding: 4,
        background: 'rgba(26, 26, 35, 0.04)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
    },
    methodIconActive: {
        background: 'rgba(40, 108, 242, 0.1)',
    },
    methodTitle: {
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '20px',
        color: '#1a1a23',
    },
    methodDesc: {
        flex: 1,
        fontSize: 14,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.6)',
    },
    connectedBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 8px',
        borderRadius: 8,
        background: '#00b55b',
        color: colors.white,
        fontSize: 12,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
    },
    emailCardActions: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 12,
        width: '100%',
    },
    emailConfirmedRow: {
        boxSizing: 'border-box',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 6,
        padding: 8,
        borderRadius: 8,
        border: '1px solid rgba(26, 26, 35, 0.12)',
        background: colors.white,
        color: '#1a1a23',
        fontSize: 14,
        lineHeight: '16px',
        width: 'fit-content',
    },
    secureTag: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '4px 8px',
        borderRadius: 8,
        background: 'rgba(0, 181, 91, 0.05)',
        color: '#009947',
        fontSize: 12,
        lineHeight: '16px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
    },
    methodActions: {
        ...grid.row,
        flexWrap: 'wrap',
        gap: 8,
    },
    methodBtnOutline: {
        boxSizing: 'border-box',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        borderRadius: 8,
        border: '1px solid rgba(26, 26, 35, 0.12)',
        background: colors.white,
        color: '#1a1a23',
        fontSize: 14,
        lineHeight: '16px',
        cursor: 'pointer',
        width: 'fit-content',
        transition: 'background-color 0.15s ease, border-color 0.15s ease',
        '&:hover:not(:disabled)': {
            background: 'rgba(26, 26, 35, 0.04)',
            borderColor: 'rgba(26, 26, 35, 0.24)',
        },
        '&:disabled': {
            opacity: 0.5,
            cursor: 'default',
        },
    },
    methodBtnToned: {
        boxSizing: 'border-box',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        borderRadius: 8,
        border: 0,
        background: 'rgba(40, 108, 242, 0.05)',
        color: colors.blueAccent,
        fontSize: 14,
        lineHeight: '16px',
        cursor: 'pointer',
        width: 'fit-content',
        transition: 'background-color 0.15s ease',
        '&:hover:not(:disabled)': {
            background: 'rgba(40, 108, 242, 0.12)',
        },
        '&:disabled': {
            opacity: 0.5,
            cursor: 'default',
        },
    },
    methodBtnDanger: {
        boxSizing: 'border-box',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '8px',
        borderRadius: 8,
        border: 0,
        background: 'rgba(229, 57, 53, 0.08)',
        color: colors.error,
        fontSize: 14,
        lineHeight: '16px',
        cursor: 'pointer',
        width: 'fit-content',
        transition: 'background-color 0.15s ease',
        '&:hover:not(:disabled)': {
            background: 'rgba(229, 57, 53, 0.14)',
        },
        '&:disabled': {
            opacity: 0.5,
            cursor: 'default',
        },
    },
    methodBoundAt: {
        fontSize: 12,
        lineHeight: '16px',
        color: 'rgba(26, 26, 35, 0.36)',
    },
    footerNote: {
        fontSize: 14,
        fontWeight: 400,
        lineHeight: '20px',
        color: 'rgba(26, 26, 35, 0.6)',
        textAlign: 'left',
        width: '100%',
    },
    totpTitle: {
        fontWeight: 'bold',
        marginBottom: indents.md,
    },
    totpHint: {
        color: colors.grey,
        fontSize: textSizes.normal,
        marginBottom: indents.md,
    },
    actionsRow: {
        ...grid.row,
        ...grid.normalCenter,
        flexWrap: 'wrap',
        gap: indents.mini,
        marginTop: indents.md,
    },
}

addStyles(authenticationSettingsStyles)
